<div class="page">

  <div class="pagehead">
    <div>
      <h1>Complaints</h1>
      <p>Raise an issue with any transaction or service and chat with support until it's resolved</p>
    </div>
    <div class="filters">
      <div class="seg" role="tablist" aria-label="Status" *ngIf="!isCreateComplaint">
        <button type="button" [class.on]="complaintStatus === 'INPROCESS'"
          (click)="complaintStatus = 'INPROCESS'; complaintType('INPROCESS')">Pending</button>
        <button type="button" [class.on]="complaintStatus === 'RESOLVED'"
          (click)="complaintStatus = 'RESOLVED'; complaintType('RESOLVED')">Resolved</button>
      </div>
      <button type="button" class="btn btn--primary" *ngIf="!isCreateComplaint" (click)="createComplaint()">
        <svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>New complaint
      </button>
      <button type="button" class="btn" *ngIf="isCreateComplaint" (click)="isCreateComplaint = false">
        <svg viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6"/></svg>Back to list
      </button>
    </div>
  </div>

  <!-- ============ CREATE ============ -->
  <div class="card create-card" *ngIf="isCreateComplaint">
    <div class="clabel"><svg viewBox="0 0 24 24"><path d="M6 3h9l3 3v15H6z"/><path d="M9 12h6M9 16h6"/></svg>New complaint</div>
    <form [formGroup]="CreateComplaintForm" class="create-form">

      <div class="er-field"
        [class.has-error]="CreateComplaintForm.get('sevice').invalid && CreateComplaintForm.get('sevice').touched">
        <label class="er-field__label" for="cp-service">Service <span class="req">*</span></label>
        <select id="cp-service" class="er-select" formControlName="sevice" required>
          <option value="" disabled selected hidden>Which service is this about?</option>
          <option *ngFor="let service of services" [value]="service.value">{{ service.serviceName }}</option>
        </select>
        <div class="er-field__error" *ngIf="CreateComplaintForm.hasError('required','sevice') && CreateComplaintForm.get('sevice').touched">Select a service</div>
      </div>

      <div class="er-field"
        [class.has-error]="CreateComplaintForm.get('details').invalid && CreateComplaintForm.get('details').touched">
        <label class="er-field__label" for="cp-details">Details <span class="req">*</span></label>
        <div class="er-field__wrap">
          <textarea id="cp-details" class="er-field__control" formControlName="details" rows="5"
            placeholder="What happened? Include the transaction ID and amount if relevant."></textarea>
        </div>
        <div class="er-field__error" *ngIf="CreateComplaintForm.hasError('required','details') && CreateComplaintForm.get('details').touched">Describe the issue</div>
      </div>

      <div class="er-field">
        <label class="er-field__label">Attachment</label>
        <div class="seg seg--sub attach-seg">
          <button type="button" [class.on]="isImage" (click)="selectedUpload('image')">Image</button>
          <button type="button" [class.on]="isVideo" (click)="selectedUpload('video')">Video</button>
        </div>

        <div class="attach-zone" *ngIf="!UserImagefilerealimageflag">
          <label class="er-dropzone attach-drop">
            <div class="er-dropzone__icon">⇪</div>
            Upload {{ isImage ? 'an image' : 'a video' }} of the issue
            <div class="er-dropzone__hint">{{ isImage ? '.jpg / .png' : '.mp4' }} · up to 29 MB</div>
            <input *ngIf="isImage" type="file" (change)="personalPhoto($event)" accept="image/x-png,image/jpeg,image/jpg" hidden>
            <input *ngIf="isVideo" type="file" (change)="personalPhoto($event)" accept="video/mp4,video/x-m4v,video/*" hidden>
          </label>
          <div class="er-field__error" *ngIf="userImagesize">File must be .jpg, .png or .mp4 and under 29 MB</div>
          <div class="er-field__error" *ngIf="errorFile2">{{ errorFile2 }}</div>
        </div>

        <div class="attach-preview" *ngIf="UserImagefilerealimageflag">
          <div class="preview-frame" *ngIf="userImageName.split('.').pop().toLowerCase() == 'pdf', else image">
            <span class="mono">{{ userImageName }}</span>
            <button type="button" class="preview-close" aria-label="Remove attachment" (click)="closeLog('photo')">×</button>
          </div>
          <ng-template #image>
            <div class="preview-frame" *ngIf="isImage">
              <img [src]="userImagefilerealimage" alt="Attachment preview">
              <button type="button" class="preview-close" aria-label="Remove attachment" (click)="closeLog('photo')">×</button>
            </div>
          </ng-template>
          <div class="preview-frame" *ngIf="isVideo">
            <video [src]="userImagefilerealimage" controls></video>
            <button type="button" class="preview-close" aria-label="Remove attachment" (click)="closeLog('photo')">×</button>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="er-btn er-btn--primary" (click)="createComplaintSubmit()">Submit complaint</button>
      </div>
    </form>
  </div>

  <!-- ============ LIST ============ -->
  <ng-container *ngIf="!isCreateComplaint">
    <div class="clist" *ngIf="ComplaintList && ComplaintList != ''">
      <div class="card card--hover complaint" *ngFor="let complaint of ComplaintList">
        <a class="c-media" title="View file"
          [href]="imgaeUrl + complaint.chats[0].complainattachment" target="_blank" download>
          <img *ngIf="!(complaint.chats[0].complainattachment && complaint.chats[0].complainattachment.includes('.mp4'))"
            [src]="imgaeUrl + complaint.chats[0].complainattachment" alt="Complaint attachment">
          <video *ngIf="complaint.chats[0].complainattachment && complaint.chats[0].complainattachment.includes('.mp4')"
            [src]="imgaeUrl + complaint.chats[0].complainattachment" controls></video>
        </a>
        <div class="c-body">
          <div class="c-top">
            <span class="c-id mono">#{{ complaint.complaintId }}</span>
            <span class="pill" [class.pend]="complaintStatus === 'INPROCESS'" [class.ok]="complaintStatus === 'RESOLVED'">
              <i class="sd"></i>{{ complaintStatus === 'INPROCESS' ? 'Pending' : 'Resolved' }}
            </span>
          </div>
          <div class="c-service">
            <ng-container *ngIf="complaint.sevice=='FINGPAY_AADHAR_SERVICE'">Aadhaar Pay</ng-container>
            <ng-container *ngIf="complaint.sevice=='FINGPAY_AEPS_BALANCEINQUIRY'">AePS balance enquiry (Kotak)</ng-container>
            <ng-container *ngIf="complaint.sevice=='YAEPS_BALANCEINQUIRY'">AePS cash withdrawal (Kotak)</ng-container>
            <ng-container *ngIf="complaint.sevice=='FINGPAY_AEPS_CASHWITHDRAWL'">AePS cash withdrawal (YesBank)</ng-container>
            <ng-container *ngIf="complaint.sevice=='FINGPAY_AEPS_MINISTATEMENT'">AePS mini statement (Kotak)</ng-container>
            <ng-container *ngIf="complaint.sevice=='YAEPS_MINISTATEMENT'">AePS mini statement (YesBank)</ng-container>
            <ng-container *ngIf="complaint.sevice=='CMS'">CMS</ng-container>
            <ng-container *ngIf="complaint.sevice=='FDMT_IMPS'">DMT IMPS (FINO)</ng-container>
            <ng-container *ngIf="complaint.sevice=='FDMT_NEFT'">DMT NEFT (FINO)</ng-container>
            <ng-container *ngIf="complaint.sevice=='CF_NEFT'">Move to Bank</ng-container>
            <ng-container *ngIf="complaint.sevice=='MATM_BALANCEINQUIRY'">mATM balance enquiry</ng-container>
            <ng-container *ngIf="complaint.sevice=='MATM_CASHWITHDRAWL'">mATM cash withdrawal</ng-container>
            <ng-container *ngIf="complaint.sevice=='RAZORPAY'">RazorPay</ng-container>
            <ng-container *ngIf="complaint.sevice=='DTH_RECHARGE'">DTH recharge</ng-container>
            <ng-container *ngIf="complaint.sevice=='MOBILE_RECHARGE'">Mobile recharge</ng-container>
            <ng-container *ngIf="complaint.sevice=='OTHER'">Other</ng-container>
            <ng-container *ngIf="complaint.sevice=='EKYC'">eKYC</ng-container>
          </div>
          <div class="c-meta">
            <span>{{ complaint.createdByName }} ({{ complaint.createdBy }})</span>
            <span class="mono">{{ complaint.createdDate | date:'d MMM yy, h:mm a' }}</span>
          </div>
          <div class="c-foot">
            <span class="c-seen" *ngIf="complaint.seen=='TRUE' && complaint.staus=='INPROCESS'">
              <i class="fas fa-check-double" aria-hidden="true"></i>
              Seen {{ complaint.seenDate | date:'d MMM yy, h:mm a' }}
            </span>
            <button type="button" class="btn c-chat" (click)="openChat(complaint, complaint.complaintId)">
              <svg viewBox="0 0 24 24"><path d="M21 12a8 8 0 01-8 8H4l2-3a8 8 0 1115-5z"/></svg>
              Open chat<span class="chat-count" *ngIf="ComplaintListCount">{{ ComplaintListCount }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card page-empty" *ngIf="!ComplaintList || ComplaintList == ''">
      <img src="../../assets/images/images/noComplaint.svg" alt="">
      <span class="t">No {{ complaintStatus === 'INPROCESS' ? 'pending' : 'resolved' }} complaints</span>
      Anything you raise appears here with its chat thread.
    </div>
  </ng-container>

</div>

